function AnnouncementsIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path d="M23.45 11.446l3.315-1.978a.893.893 0 011.323.982.89.89 0 01-.407.547l-3.294 1.97a.887.887 0 01-.807.055.876.876 0 01-.394-.352.89.89 0 01.265-1.224zm2.18 2.906l-1.646.035a.891.891 0 00-.764 1.307.876.876 0 00.803.47l1.646-.036a.888.888 0 10-.034-1.774l-.005-.002zm2.224 5.244l-3.396-1.847a.892.892 0 00-1.248 1.034c.06.22.203.41.4.528l3.396 1.847.078.033a.888.888 0 001.222-1.09.886.886 0 00-.452-.505zM6.228 18.54a.5.5 0 00.509.493l.08-.01 1.08-.188 1.532 4.239a1.549 1.549 0 002.095.885 1.55 1.55 0 00.82-1.951L11.3 19.197l9.855 3.526a.5.5 0 00.67-.476l-.252-13.84a.5.5 0 00-.687-.454L9.393 12.54l-2.701-.374a.502.502 0 00-.57.508l.106 5.866z" />
      </g>
    </svg>
  )
}

export default AnnouncementsIcon
